export default __webpack_public_path__ + "static/media/successcheck.f3c187a7.svg";